<script setup>
import { learnMoreOpened } from "@/analytics/events";
import { trackEvent } from "@/analytics/track";

import BaseButton from "./BaseButton.vue";
import BaseDropdown from "./BaseDropdown.vue";
</script>

<template>
  <BaseDropdown align="right" @open="trackEvent(learnMoreOpened())">
    <template #trigger="{ isOpen }">
      <BaseButton
        as="div"
        variant="outlined"
        color="grey"
        icon-before="general/learn"
        :icon-after="isOpen ? 'system/chevron-up' : 'system/chevron-down'"
      >
        Learn
      </BaseButton>
    </template>
    <slot />
  </BaseDropdown>
</template>
